import React from 'react';

const  FilterIcon = (props) => (
   <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.083 11.2499L16.4222 6.91075C16.5788 6.75409 16.6663 6.54242 16.6663 6.32159V4.16659C16.6663 3.70659 16.293 3.33325 15.833 3.33325H4.16634C3.70634 3.33325 3.33301 3.70659 3.33301 4.16659V6.32159C3.33301 6.54242 3.42051 6.75492 3.57717 6.91075L7.91634 11.2499" stroke="#1D1917" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.91699 11.25V16.4575C7.91699 17.135 8.55366 17.6325 9.21116 17.4683L11.2945 16.9475C11.7578 16.8317 12.0837 16.415 12.0837 15.9367V11.25" stroke="#1D1917" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

);

export default FilterIcon;